export default __webpack_public_path__ + "static/media/Rainfall.09c5f540.webm";